export {
  inputBorderStyles,
  INPUT_HEIGHT,
  disabledInputStylesNoBorder,
  inputStylesNoBorder,
  inputStyles,
  InputWrapper,
  FormInputLabel,
  Input,
} from "./Input";
export type { IProps } from "./Input";
